import * as f from "react";
function s(n, u) {
  if (typeof n == "function")
    return n(u);
  n != null && (n.current = u);
}
function l(...n) {
  return (u) => {
    let o = !1;
    const c = n.map((e) => {
      const t = s(e, u);
      return !o && typeof t == "function" && (o = !0), t;
    });
    if (o)
      return () => {
        for (let e = 0; e < c.length; e++) {
          const t = c[e];
          typeof t == "function" ? t() : s(n[e], null);
        }
      };
  };
}
function i(...n) {
  return f.useCallback(l(...n), n);
}
export {
  l as c,
  i as u
};
